module.exports = __webpack_public_path__ + "img/4.828820f7.svg";